// extracted by mini-css-extract-plugin
module.exports = {"standOutNavItem":"Navigation_standOutNavItem__3XbPj","socialIcons":"Navigation_socialIcons__2Qolv"};